import React, { memo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BREADCRUMB_HEIGHT, StickyBreadcrumb, StickyBreadcrumbSlot } from '../styled';
import { BreadcrumbItem } from '../useBreadcrumbPath';

interface StickyBreadcrumbProps {
  path: BreadcrumbItem[];
}

const containerVariants = {
  hidden: { y: -BREADCRUMB_HEIGHT, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.14,
      ease: 'easeOut',
    },
  },
  exit: {
    y: -BREADCRUMB_HEIGHT,
    opacity: 0,
    transition: { duration: 0, ease: 'linear' },
  },
};

export const StickyBreadcrumbBar = memo(({ path }: StickyBreadcrumbProps) => {
  const isVisible = path.length > 0;

  return (
    <StickyBreadcrumbSlot>
      <AnimatePresence initial={false}>
        {isVisible && (
          <StickyBreadcrumb variants={containerVariants} initial="hidden" animate="visible" exit="exit">
            {path.map((item, index) => (
              <React.Fragment key={item.key}>
                {index > 0 && (
                  <motion.span
                    className="breadcrumb-separator"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.1, ease: 'easeOut' }}
                  >
                    {'>'}
                  </motion.span>
                )}
                <motion.span
                  className="breadcrumb-item"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.12, ease: 'easeOut' }}
                >
                  {item.name}
                </motion.span>
              </React.Fragment>
            ))}
          </StickyBreadcrumb>
        )}
      </AnimatePresence>
    </StickyBreadcrumbSlot>
  );
});


